import { ReactNode, useEffect, useRef, useState } from 'react';

export interface LaidOutAttributeBoxesProps {
  items: ReactNode[];
}

export function LaidOutAttributeBoxes({ items }: LaidOutAttributeBoxesProps) {
  const boxRef = useRef<HTMLDivElement>(null);
  const [cols, setCols] = useState(0);

  const GAP = 8;
  const MIN_WIDTH = 150;

  useEffect(() => {
    // on initial render
    setTimeout(() => {
      updateSize();
    }, 0);
    // gets the size and updates state
    function updateSize() {
      if (boxRef.current) {
        const { width } = boxRef.current.getBoundingClientRect() ?? 0;

        let maxItems = Math.min(Math.floor(width / (MIN_WIDTH + GAP)), items.length);

        while (items.length % maxItems === 1 && maxItems > 2) {
          maxItems--;
        }

        setCols(maxItems);
      }
    }
    // event listener
    window.addEventListener('resize', updateSize);
    // remove the event listener before the component gets unmounted
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <>
      <div className={`grid grid-cols-${cols} gap-[${GAP}px] gap-y-2 pb-2`} ref={boxRef}>
        {...items}
      </div>
      {/* Here as we do not use the class anywhere else and Tailwind is not generating grid-cols-3 unless somewhere present */}
      <div className="hidden grid-cols-3" />
    </>
  );
}
